import { Api, Currency, CurrencySettings, DateUtil } from "@mcleod/core";
import { AutogenLayoutEscrowTransactionFields } from "./autogen/AutogenLayoutEscrowTransactionFields";
import { DataSourceMode, DataSourceModeChangeEvent, DropdownItem, LookupModelSearchEvent, LookupModelSelectionEvent, BlurEvent } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";

export class EscrowTransactionFields extends AutogenLayoutEscrowTransactionFields {

    private multiCurrencyEnabled = CurrencySettings.getSingleton().multiCurrencyEnabled();
    private payeeCurrencyCode = CurrencySettings.getFunctionalCurrency();

    onLoad(): void | Promise<void> {
        this.mainDataSource.doBeforeDataSourcePost = async () => {
            const response = await Api.post("lme/settlement/most-recent-escrow-transaction-date", {
                payee_id: this.activeRow.get("payee_id"),
                glid: this.activeRow.get("glid"),
                update: this.mainDataSource.mode === DataSourceMode.UPDATE,
            });
            if (response.data && response.data.length > 0) {
                const date = response.data[0]?.most_recent_date;
                if (date) {
                    const recentDate = DateUtil.parseDate(date);
                    const checkDate = this.activeRow.getDate("check_date");
                    if (checkDate < recentDate) {
                        CommonDialogs.showMessage(`Date cannot be before the most recent Balance record ${DateUtil.formatDate(recentDate)}.`);
                        return false;
                    }
                }
            }
            return true;
        }
    }

    /** This is an event handler for the afterModeChange event of sourceEscrowTransaction. */
    sourceEscrowTransactionAfterModeChange(event: DataSourceModeChangeEvent) {
        if(event.newMode == DataSourceMode.ADD) {
            this.textboxCheckDate.caption = "Date";
            this.activeRow.set("check_date", new Date());
            this.textboxEffect.items = [new DropdownItem("D", "Deposit"), new DropdownItem("W", "Withdrawal")];
        }
        if(event.newMode === DataSourceMode.UPDATE) {
            const canEdit = this.activeRow.getBoolean("can_edit", false);
            this.textboxCheckDate.enabled = canEdit;
            this.textboxCheckDate.requiredDuringUpdate = canEdit;
        }
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxGlid. */
    textboxGlidBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.isactive = "Y";
        event.filter.is_escrow = "Y";
    }

    /** This is an event handler for the onLookupModelSelection event of textboxPayeeId. */
    textboxPayeeIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (!this.multiCurrencyEnabled) {
            return;
        }
        const functionalCurrency = CurrencySettings.getFunctionalCurrency();
        this.payeeCurrencyCode = event.hasSelection()
            ? (event.selection.get("currency") ?? functionalCurrency)
            : functionalCurrency;

        const existing = this.activeRow.getCurrency("amount");
        if (!existing) return;

        this.activeRow.set("amount", new Currency({
            amount: existing.getAmount(),
            currency_code: this.payeeCurrencyCode
        }));
    }

    /** This is an event handler for the onBlur event of textboxAmount. */
    textboxAmountOnBlur(event: BlurEvent) {
        if (!this.multiCurrencyEnabled) {
            return;
        }
        const existing = this.activeRow.getCurrency("amount");
        if (!existing) {
             return;
        }

        this.activeRow.set("amount", new Currency({
            amount: existing.getAmount(),
            currency_code: this.payeeCurrencyCode
        }));
    }
}
